var gallery = {

    configuration: {
        productId: null
    },

    elements: {
        thumbnails: null,
        images: null
    },

    init: function() {
        if(typeof BoosterTheme == 'undefined') {
            return;
        }

        if(!this.getElements()) {
            return;
        }

        this.loadProductId();

        if(!this.configuration.productId) {
            this.showAllImages();

            return;
        }

        this.filterImages();
        this.setEvents();
    },

    getElements: function() {
        this.elements.thumbnails = jQuery('.gallery__thumbnail');
        if(!this.elements.thumbnails.length) {
            return false;
        }

        this.elements.images = jQuery('.gallery__image');
        if(!this.elements.images.length) {
            return false;
        }

        return true;
    },

    loadProductId: function() {
        var current = BoosterTheme.swatches.current;

        if(typeof current == 'undefined') {
            return;
        }

        var productIds = Object.keys(current);

        if(typeof productIds[0] == 'undefined') {
            return;
        }

        this.configuration.productId = productIds[0];
    },

    showAllImages: function() {
      this.elements.thumbnails.removeClass('gallery__thumbnail--disabled');
      this.elements.images.removeClass('gallery__image--disabled');
    },

    filterImages: function() {
        var variantId = BoosterTheme.swatches.findVariant(this.configuration.productId);

        if(typeof variantId == 'undefined') {
            return;
        }

        if(!variantId) {
            return;
        }

        this.elements.thumbnails.not('[data-variant-id="' + variantId + '"]').addClass('gallery__thumbnail--disabled');
        this.elements.thumbnails.filter('[data-variant-id="' + variantId + '"]').removeClass('gallery__thumbnail--disabled');

        this.elements.images.not('[data-variant-id="' + variantId + '"]').addClass('gallery__image--disabled');
        this.elements.images.filter('[data-variant-id="' + variantId + '"]').removeClass('gallery__image--disabled');
    },

    setEvents: function() {
        var _self = this;

        BoosterTheme.swatches.THEME_UTILS.events.on('booster:swatch:update', function(arguments) {
            _self.filterImages();
        });
    }

};

function initGallery() {
  if(typeof BoosterTheme == 'undefined') {
    setTimeout(initGallery, 200);

    return;
  }

  gallery.init();
}

jQuery(document).ready(function() {
  initGallery();
});
